"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseThemeStyles = createUseThemeStyles;
const react_jss_1 = require("react-jss");
function createUseThemeStyles(styles, options) {
    return (0, react_jss_1.createUseStyles)(styles, options);
}
